import { createIconComponent } from '../../factory/create-icon-component';
export const Badge1Icon = createIconComponent(
  'Badge1Icon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM11.7168 7.78906L8.39648 9.60059L9.26367 11.1904L11.2451 10.1094V16.7344H13.0557V7.05859L11.7168 7.78906Z"
      fill="currentColor"
    />
  </svg>,
);
